// removed by extract-text-webpack-plugin
module.exports = {"industryChart":"common_industryChart_2DZhc","performanceChart":"common_performanceChart_3ljN2","quarterMatchChart":"common_quarterMatchChart_3BzhM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/common.scss
// module id = 401
// module chunks = 0